import Helper from '../helpers';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

export const SubscriptionOfferService = {
  async createOffer(venueKey, offerData) {
    const token = await Helper.getCookie('wh-jwt');
    const response = await fetch(`${apiBaseUrl}/api/SubscriptionOffer/create/${venueKey}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(offerData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || error.Message || 'Failed to create offer');
    }

    return response.json();
  },

  async getVenueOffers(venueKey) {
    const token = await Helper.getCookie('wh-jwt');
    const response = await fetch(`${apiBaseUrl}/api/SubscriptionOffer/list/${venueKey}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch offers');
    }

    return response.json();
  },

  async cancelOffer(venueKey, offerId) {
    const token = await Helper.getCookie('wh-jwt');
    const response = await fetch(`${apiBaseUrl}/api/SubscriptionOffer/cancel/${venueKey}/${offerId}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to cancel offer');
    }

    return response.json();
  },

  async getOfferDetails(inviteCode) {
    const response = await fetch(`${apiBaseUrl}/api/SubscriptionOffer/details/${inviteCode}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch offer details');
    }

    return response.json();
  },

  async validateOffer(inviteCode) {
    const response = await fetch(`${apiBaseUrl}/api/SubscriptionOffer/validate/${inviteCode}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to validate offer');
    }

    return response.json();
  },

  async offerToExistingUser(venueKey, offerData) {
    const token = await Helper.getCookie('wh-jwt');
    const response = await fetch(`${apiBaseUrl}/api/SubscriptionOffer/offer-to-existing-user/${venueKey}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(offerData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || error.Message || 'Failed to create offer');
    }

    return response.json();
  },

  async acceptOffer(inviteCode) {
    const token = await Helper.getCookie('wh-jwt');
    const response = await fetch(`${apiBaseUrl}/api/SubscriptionOffer/accept/${inviteCode}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || error.Message || 'Failed to accept offer');
    }

    return response.json();
  },

  async initiateOfferPayment(inviteCode) {
    const token = await Helper.getCookie('wh-jwt');
    const response = await fetch(`${apiBaseUrl}/api/PaymentAdmin/initiate-offer-payment`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({ inviteCode })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || error.Message || 'Failed to initiate payment');
    }

    return response.json();
  }
};
